import { PlaneView } from '../../../../view/views/PlaneView';
import { SvgCursor } from './SvgCursor';

export class RotationCursor extends SvgCursor {
    constructor(views: PlaneView[] | null) {
        super(views);
    }

    protected getSvgString(): string {
        return `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"><path d="M21 12a9 9 0 1 1-9-9c2.52 0 4.93 1 6.74 2.74L21 8"/><path d="M21 3v5h-5"/></svg>`;
    }

    protected getFallbackCursor(): string {
        return 'alias';
    }
}
